import { render } from "./HomeGoalsPage.vue?vue&type=template&id=20516423&ts=true"
import script from "./HomeGoalsPage.vue?vue&type=script&lang=ts"
export * from "./HomeGoalsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__